<template>
	<div class="max-w-2xl mx-auto py-4 mb-8 px-4 md:px-0">
		<h1 class="text-2xl mb-6 font-bold dark:text-white">Список подсайтов</h1>
		<div class="space-y-4">
			<channel-item
				v-for="channel in channels"
				:channel="channel"
			></channel-item>
		</div>
	</div>
</template>
<script>

import Client from "../../js/modules/Client";
import {notify} from "@kyvg/vue3-notification";

export default {
	data() {
		return {
			channels: [],
		};
	},
	mounted() {
		this.loadChannels();
	},
	methods: {
		loadChannels() {
			Client.get('/api/v1.1/channel/list?conditions[]=visibleOnly&conditions[]=withSubscribed&conditions[]=withSubscribersCount')
				.then(response => {
					this.channels = response.data.data;
				})
				.catch(e => {
					notify({
						type: 'error',
						text: 'Вот так бездарно и прошла моя попытка загрузить список подсайтов',
					})
				})
		},
	},
}
</script>
